var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMoneyGrowth(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 64 64",
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 14,
    fill: "#ffbe1d",
    r: 11
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11 35.93v19.07h-7v-13z",
    fill: "#44b260"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18 29.87v25.13h-7v-19.07z",
    fill: "#8dc691"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25 33.2v21.8h-7v-25.13l1-.87z",
    fill: "#44b260"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32 33.19v21.81h-7v-21.8l4 2.8z",
    fill: "#8dc691"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46 23.22v31.78h-7v-28.37l5.2-4.88c.54.55 1.14 1.05 1.8 1.47z",
    fill: "#8dc691"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53 24.95v30.05h-7v-31.78c1.72 1.13 3.78 1.78 6 1.78.34 0 .67-.02 1-.05z",
    fill: "#44b260"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4 42v4.633l7-6.07v-4.633z",
    fill: "#379b4a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11 35.93v4.633l2.291-1.987 4.709-4.076v-4.63z",
    fill: "#79a879"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19 29-1 .87v4.63l1.231-1.066 5.769 4.038v-4.272z",
    fill: "#379b4a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44.2 21.75-5.2 4.88v4.793l4.473-4.192c.53-.496 1.315-.625 1.961-.296.184.094.379.162.566.247v-3.962c-.66-.42-1.26-.92-1.8-1.47z",
    fill: "#79a879"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29 36-4-2.8v4.272l2.854 1.998c.854.598 2.01.515 2.771-.197l1.375-1.289v-4.794z",
    fill: "#79a879"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52 25c-2.22 0-4.28-.65-6-1.78v3.963c1.862.849 3.892 1.317 6 1.317.338 0 .668-.029 1-.052v-3.498c-.33.03-.66.05-1 .05z",
    fill: "#379b4a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32 33.19v4.794l7-6.561v-4.793z",
    fill: "#379b4a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 14,
    fill: "#f4971e",
    r: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1 55h55v6h-55z",
    fill: "#7f99a5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1 55h55v3h-55z",
    fill: "#aec4cc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39 26.63-7 6.56-3 2.81-4-2.8-6-4.2-1 .87-7 6.06-7 6.07-3-5 18-15 10 7 9.58-8.63-6.24-1.26.66-4.11 8.23 1.26c.44 2.12 1.49 4.01 2.97 5.49z",
    fill: "#0d9b50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39 26.63v28.37h-7v-21.81z",
    fill: "#44b260"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#252525"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m50 15h4c.551 0 1 .449 1 1s-.449 1-1 1h-5c-.552 0-1 .448-1 1s.448 1 1 1h2v1c0 .552.448 1 1 1s1-.448 1-1v-1h1c1.654 0 3-1.346 3-3s-1.346-3-3-3h-4c-.551 0-1-.449-1-1s.449-1 1-1h5c.552 0 1-.448 1-1s-.448-1-1-1h-2v-1c0-.552-.448-1-1-1s-1 .448-1 1v1h-1c-1.654 0-3 1.346-3 3s1.346 3 3 3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64 14c0-6.617-5.383-12-12-12s-12 5.383-12 12c0 .356.023.713.054 1.068l-6.903-1.057c-.547-.089-1.052.287-1.139.83l-.66 4.11c-.085.53.263 1.033.79 1.139l4.292.867-7.513 6.768-9.349-6.544c-.369-.259-.867-.238-1.213.051l-18 15c-.379.315-.471.86-.217 1.283l2.858 4.762v11.723h-2c-.552 0-1 .448-1 1v6c0 .552.448 1 1 1h55c.552 0 1-.448 1-1v-6c0-.552-.448-1-1-1h-2v-28.178c5.76-.951 10-5.877 10-11.822zm-12-10c5.514 0 10 4.486 10 10 0 5.213-3.907 9.492-9.09 9.954-2.199.202-4.496-.344-6.373-1.577-.566-.361-1.113-.808-1.63-1.334-1.373-1.373-2.306-3.096-2.698-4.984-.139-.678-.209-1.37-.209-2.059 0-5.514 4.486-10 10-10zm-12 50v-26.942l4.21-3.947c.259.223.522.426.79.618v30.271zm-7 0v-20.379l5-4.688v25.067zm-7 0v-18.879l2.427 1.699c.387.271.912.234 1.257-.089l1.316-1.235v18.504zm-7 0v-23.674l.067-.058 4.933 3.453v20.279zm-7 0v-17.609l5-4.333v21.942zm7.053-30.742 9.374 6.562c.381.267.895.235 1.243-.076l9.58-8.63c.281-.253.395-.643.295-1.007-.1-.365-.396-.642-.767-.716l-5.298-1.07.351-2.181 6.589 1.008c.452 1.674 1.263 3.221 2.379 4.547l-13.89 13.02-9.335-6.535c-.375-.263-.883-.237-1.229.065l-14.1 12.219-1.947-3.244zm-14.053 19.199 5-4.333v15.876h-5zm50 17.543h-53v-4h53zm-8-6v-29.087c1.553.714 3.253 1.087 5 1.087v28z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9 21.714c.23 0 .462-.079.65-.241l8.371-7.175 4.354 3.482c.36.288.873.292 1.238.009l9-7c.283-.22.426-.575.376-.929-.05-.355-.286-.656-.619-.789l-5-2c-.516-.204-1.095.044-1.3.557s.044 1.095.557 1.3l3.381 1.352-7.001 5.446-4.384-3.507c-.375-.3-.911-.292-1.275.021l-9 7.714c-.419.359-.468.991-.108 1.41.198.232.479.35.76.35z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4 26c.23 0 .462-.079.65-.241l2.333-2c.419-.359.468-.991.108-1.41s-.992-.468-1.41-.108l-2.333 2c-.419.359-.468.991-.108 1.41.198.23.479.349.76.349z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyGrowth);
export default __webpack_public_path__ + "static/media/moneyGrowth.c7dbe825d649df447db1b2a03a69897a.svg";
export { ForwardRef as ReactComponent };